/**
 * useExportTransactions Hook
 * 
 * Hook para exportação de lançamentos
 */

import { useMutation } from '@tanstack/react-query';
import { exportTransactions, downloadExportFile } from '../services/export.service';
import type { ExportFilters, ExportData } from '../../../types/export-import';
import { toast } from 'sonner';

interface UseExportTransactionsOptions {
  companyId: string;
  companyName: string;
}

export function useExportTransactions({ companyId, companyName }: UseExportTransactionsOptions) {
  const exportMutation = useMutation({
    mutationFn: async (filters: ExportFilters): Promise<ExportData> => {
      return exportTransactions(companyId, companyName, filters);
    },
    onSuccess: (data) => {
      // Download automático
      downloadExportFile(data);
      toast.success(`${data.transactions.length} lançamentos exportados com sucesso!`);
    },
    onError: (error) => {
      console.error('[useExportTransactions] Error:', error);
      toast.error('Erro ao exportar lançamentos', {
        description: error instanceof Error ? error.message : 'Erro desconhecido',
      });
    },
  });

  return {
    exportTransactions: exportMutation.mutate,
    isExporting: exportMutation.isPending,
    isSuccess: exportMutation.isSuccess,
    isError: exportMutation.isError,
    error: exportMutation.error,
    data: exportMutation.data,
  };
}

